import { UCCFilingDocumentData } from "../../../../../lib/documents/ucc-filing-document.model";

export enum UCCFilingStatus {
    None = "none",
    Pending = "pending",
    Recorded = "recorded",
    Rejected = "rejected",
    EnforcementInProgress = "enforcement-in-progress",
    Enforced = "enforced",
    RescindInProgress = "rescind-in-progress",
    Rescinded = "rescinded"
}

export interface UCCFilingData {
    status?: UCCFilingStatus,
    pendingOnUtc?: Date,
    enforcedOnUtc?: Date,
    rescindedOnUtc?: Date,
    workOrderId?: string,
    errors?: string[],
    document?: UCCFilingDocumentData,
    canResubmitUCC?: boolean,
    canRefreshUCC?: boolean
}

export const DEFAULT_UCC_FILING_DATA: UCCFilingData = {
  status: UCCFilingStatus.None,
  errors: []
};

export const UCCFilingStatusLabel = new Map<string, string>([
  [UCCFilingStatus.None, "None"],
  [UCCFilingStatus.Pending, "Pending"],
  [UCCFilingStatus.Recorded, "Recorded"],
  [UCCFilingStatus.Rejected, "Rejected"],
  [UCCFilingStatus.EnforcementInProgress, "Enforcement in progress"],
  [UCCFilingStatus.Enforced, "Enforced"],
  [UCCFilingStatus.RescindInProgress, "Rescind in progress"],
  [UCCFilingStatus.Rescinded, "Rescinded"]
]);